import { Device } from "../models/device";
import { DeviceInfo } from "../models/device-info";
import { getDeviceModelFromModelId } from "../models/device-model";
import { baliApiClient } from "./bali-client";

type DeviceResponse = (Omit<Device, "model" | "active"> & { model: number })[];

export const getAllDevices = async (): Promise<Device[]> => {
  const { devices } = await baliApiClient.get<{
    devices: DeviceResponse;
  }>("map/home-page/team/devices");

  return devices.map((device) => ({
    ...device,
    model: getDeviceModelFromModelId(device.model),
    active: true,
  }));
};

export const getAllActiveDevices = async (): Promise<Device[]> => {
  const { activeDevices } = await baliApiClient.get<{
    activeDevices: DeviceResponse;
  }>("map/home-page/team/devices/active");

  return activeDevices.map((device) => ({
    ...device,
    model: getDeviceModelFromModelId(device.model),
    active: true,
  }));
};

export const getAllInactiveDevices = async (): Promise<Device[]> => {
  const { inactiveDevices } = await baliApiClient.get<{
    inactiveDevices: DeviceResponse;
  }>("map/home-page/team/devices/inactive");

  return inactiveDevices.map((device) => ({
    ...device,
    model: getDeviceModelFromModelId(device.model),
    active: false,
  }));
};

export const getDeviceInfo = async (deviceId: number): Promise<DeviceInfo> =>
  await baliApiClient.get<DeviceInfo>(
    `map/home-page/team/device/${deviceId}/info`
  );
